module.exports = __webpack_public_path__ + "img/image-fill.b5c0a757.svg";